<template>
  <div class="">
    <router-link
      :to="{
        name: 'approve-retainership-card-request',
        query: { groupId: data.id, companyId: $route.query.companyId },
      }"
    >
      <button
        style="text-decoration: none; color: rgb(75, 44, 114); width: auto"
        class="btn dealers_btn mr-2"
        :title="$t('text.clickButtons.mapBranchesToViewDashboard')"
      >
        Approve
      </button>
    </router-link>

    <router-link
      :to="{
        name: 'our_branches',
        query: { groupId: data.id, companyId: $route.query.companyId },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114)"
      class="btn dealers_btn mr-2"
      :title="$t('text.clickButtons.branches')"
      v-if="data.numberOfBranches > 0 && !this.$route.query.companyID"
    >
      {{ $t("text.clickButtons.branches") }} {{ data.numberOfBranches }}
    </router-link>

    <router-link
      :to="{
        name: 'company_users',
        query: {
          groupId: data.id,
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : data.companyId,
        },
      }"
      style="text-decoration: none; color: rgb(75, 44, 114)"
      class="btn dealers_btn mr-2"
      :title="$t('text.clickButtons.users')"
      v-if="data.numberOfUsers > 0 && !this.$route.query.companyID"
    >
      {{ $t("text.clickButtons.users") }} {{ data.numberOfUsers }}
    </router-link>
  </div>
</template>
  
  <script>
import configObject from "@/config";
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {},
  methods: {
    mapToBranch: function (id) {
      this.$eventHub.$emit("_mapGroupToBranch", id);
    },

    approveRequest: function (data) {
      this.$eventHub.$emit("approveCardRequest", data);
    },
  },
};
</script>
  